import "./contactSection.css";

import React from "react";
import { connect } from "react-redux";
import { CircularProgress } from "@mui/material";

import { notifSelectors } from "../../logic/rootSelectors";
import _contact from "../../logic/contact";
import { CONTACT_DETAILS, LOADING_STATE, LS_ITEM } from "../../utils/stateTypes";
import Reveal from "../general/Reveal";

const EMPTY = {
  firstName: "",
  lastName: "",
  phone: "",
  email: "",
  message: "",
};

const FIELDS = [
  {
    prop: "firstName",
    label: "First name",
    autoComplete: "given-name",
    required: true,
  },
  {
    prop: "lastName",
    label: "Last name",
    autoComplete: "family-name",
  },
  {
    prop: "phone",
    label: "Phone",
    type: "tel",
    autoComplete: "tel",
  },
  {
    prop: "email",
    label: "Email",
    type: "email",
    autoComplete: "email",
    required: true,
  },
];

const ContactSection = ({ sendLS, sendContactMessage, className = "" }) => {
  const [form, setForm] = React.useState(EMPTY);
  const isSending = sendLS === LOADING_STATE.LOADING;

  const update = (prop) => (e) => setForm({ ...form, [prop]: e.target.value });

  const onSubmit = (e) => {
    e.preventDefault();
    sendContactMessage(form, () => setForm(EMPTY));
  };

  return (
    <section
      id={"contact"}
      className={`section bg-green contact ${className}`}
    >
      <div className={"container contact-grid"}>
        <Reveal className={"contact-form-wrap"}>
          <h2 className={"contact-heading"}>
            {"Ready to "}
            <span className={"script"}>Chat?</span>
          </h2>
          <p className={"contact-direct"}>
            {"Email "}
            <a href={`mailto:${CONTACT_DETAILS.EMAIL}`}>{CONTACT_DETAILS.EMAIL}</a>
            {", call "}
            <a href={CONTACT_DETAILS.PHONE_LINK}>{CONTACT_DETAILS.PHONE}</a>
            {" or send a message below."}
          </p>
          <form
            className={"contact-form"}
            onSubmit={onSubmit}
          >
            {FIELDS.map((field) => (
              <label
                key={field.prop}
                className={"field"}
              >
                <span>
                  {field.label}
                  {field.required ? <em aria-hidden={"true"}> *</em> : null}
                </span>
                <input
                  type={field.type || "text"}
                  value={form[field.prop]}
                  onChange={update(field.prop)}
                  autoComplete={field.autoComplete}
                  required={field.required}
                  maxLength={(field.prop === "phone") ? 30 : 100}
                />
              </label>
            ))}
            <label className={"field"}>
              <span>
                How can we assist?
                <em aria-hidden={"true"}> *</em>
              </span>
              <textarea
                value={form.message}
                onChange={update("message")}
                required
                rows={4}
                maxLength={5000}
              />
            </label>
            <button
              type={"submit"}
              className={"btn-pill btn-outline contact-submit"}
              disabled={isSending}
            >
              {isSending ? (
                <CircularProgress
                  size={22}
                  color={"secondary"}
                />
              ) : "Submit"}
            </button>
          </form>
        </Reveal>
        <Reveal
          className={"contact-image"}
          delay={0.15}
        >
          <img
            src={"/images/contact-illustration.webp"}
            alt={"Illustration of a couple choosing a new home online"}
            width={1100}
            height={858}
            loading={"lazy"}
          />
        </Reveal>
      </div>
    </section>
  );
};

const mapStateToProps = (state) => {
  return {
    sendLS: notifSelectors.getLoadState(state)(LS_ITEM.CONTACT_SEND),
  };
};

export default connect(
  mapStateToProps,
  {
    sendContactMessage: _contact.actions.sendContactMessage,
  },
)(ContactSection);
